export default "__VITE_ASSET__CtpRw3NA__"